import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const Content = lazy(() => import("./Content"));

const globalSearchRoutes: RouteObject[] = [
  {
    path: "/search",
    element: (
      <Suspense fallback={<Loading />}>
        <Content />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/search",
    element: (
      <Suspense fallback={<Loading />}>
        <Content />
      </Suspense>
    ),
  },
];

export default globalSearchRoutes;
